module.exports = __webpack_public_path__ + "img/8f2cfd8.png";